import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ProgressBarForeground extends BackgroundColor {

  // -------------------//
  // Static Class Vars //
  // -------------------//

  static userInterfaceComponent = {
    label: "Foreground Color",
    component: inspectorTools.COLOR_PICKER,
    props: {
      width: "fill",
      displayAsSelectInput: true,
      colorContext: "Backgrounds",
    },
  };

  static defaultValue = {
    value: "striking",
    source: "theme.background",
  };
}
